import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }
  static targets = ["button"]

  copy() {
    navigator.clipboard.writeText(this.contentValue).then(() => {
      this.showSuccess()
    }).catch((err) => {
      console.error('Could not copy text: ', err)
      alert('Failed to copy URL to clipboard')
    })
  }

  showSuccess() {
    const button = this.buttonTarget
    const originalText = button.textContent

    button.textContent = 'Copied!'
    button.style.backgroundColor = '#16a34a' // green-600

    setTimeout(() => {
      button.textContent = originalText
      button.style.backgroundColor = ''
    }, 2000)
  }
}

